import type { ReactNode } from 'react';
import { Button } from '@mui/material';
import Add from '@mui/icons-material/Add';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
  actionIcon?: ReactNode;
  children?: ReactNode;
  /** Heading level; a page embedded in another page passes 2. */
  level?: 1 | 2;
}

/** Same page head as the Hub pages (`hub-page-head` in features/hub/hub.css). */
export function PageHeader({ title, subtitle, actionLabel, onAction, actionDisabled, actionIcon = <Add />, children, level = 1 }: PageHeaderProps) {
  const Heading = level === 1 ? 'h1' : 'h2';
  const hasActions = Boolean(children || actionLabel);
  return (
    <header className={`hub-page-head${level === 2 ? ' is-sub' : ''}`}>
      <div>
        <Heading>{title}</Heading>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {hasActions ? (
        <div className="hub-page-actions">
          {children}
          {actionLabel ? (
            <Button variant="contained" startIcon={actionIcon} onClick={onAction} disabled={actionDisabled}>
              {actionLabel}
            </Button>
          ) : null}
        </div>
      ) : null}
    </header>
  );
}
